window.addEventListener('DOMContentLoaded', function () {
    $('#ranking').gesamtuebersicht();
    $('.ansichten').addClass('ktabs').ktabs();
    $('.wertungen').addClass('ktabs').ktabs();
});
